import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ItemsReceivedDetail = {
    name: NAME,
    apiProvider,
    router,
};
